// Customer messages never echo internal provider diagnostics.
export function readingError(error, hasPrevious = false) {
  const status = error?.response?.status;
  if (String(error?.code || "").startsWith("OPENAI_READING_TIME_LIMIT_REACHED")) return hasPrevious ? "La nuova lettura ha superato il tempo massimo. Il risultato precedente è ancora disponibile." : "La lettura ha superato il tempo massimo. Puoi riprovare o contattare l’assistenza.";
  if (status === 401) return "La sessione è scaduta. Accedi nuovamente.";
  if (status === 403) return "Il tuo account non può avviare questa lettura. Contatta l'amministratore.";
  if (status === 402 || status === 429) return "La lettura non è disponibile al momento. Controlla il pacchetto e i consumi o riprova più tardi.";
  if (status === 409) return "La preparazione è cambiata o una lettura è già in corso. Aggiorna lo stato prima di riprovare.";
  return hasPrevious ? "L'ultima lettura non è stata completata. Il risultato precedente è ancora disponibile." : "Non è stato possibile completare la lettura. Puoi riprovare; se il problema continua, contatta l'assistenza.";
}
export function readingDuration(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return "";
  const total = Math.floor(seconds);
  return total < 60 ? `${total} s` : `${Math.floor(total / 60)} min ${total % 60} s`;
}

